import { render, staticRenderFns } from "./DraggablelActivitytems.vue?vue&type=template&id=f3bb47fa&scoped=true"
import script from "./DraggablelActivitytems.vue?vue&type=script&lang=js"
export * from "./DraggablelActivitytems.vue?vue&type=script&lang=js"
import style0 from "./DraggablelActivitytems.vue?vue&type=style&index=0&id=f3bb47fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bb47fa",
  null
  
)

export default component.exports